import * as yup from 'yup';

export const initialValues = {
  username: '',
  password: '',
};

export const validationSchema = yup.object().shape({
  username: yup.string().required('Username is required!'),
  password: yup.string().required('Password is required!'),
});

// TODO: TFR-47 move hooks utils and effects into proper repository
